import Toolbar from '@mui/material/Toolbar'
import AppBar from '@mui/material/AppBar'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'
import Box from '@mui/material/Box'

import NotificationCenter from '../../NotificationCenter'
import { DRAWER_WIDTH } from '../constants'

export default function HsHeaderBar({
  coproprietaire,
  handleDrawerToggle,
  headerBarTitle,
}) {
  return (
    <AppBar
      position="fixed"
      sx={{
        width: { lg: `calc(100% - ${DRAWER_WIDTH}px)` },
        ml: { lg: `${DRAWER_WIDTH}px` },
      }}
    >
      <Toolbar>
        {/* Hide on mobile */}
        <Typography
          variant="coproName"
          fontSize="18px"
          sx={{ display: { xs: 'none', lg: 'block' } }}
        >
          {coproprietaire && coproprietaire.copro.libelle
            ? coproprietaire.libelle + ' - ' + coproprietaire.copro.libelle
            : ''}
        </Typography>
        {/* Align title with padding 24px for both sides */}
        <Typography
          variant="pageTitle"
          position="absolute"
          width="calc(100% - 48px)"
          textAlign="center"
          fontSize="18px"
        >
          {headerBarTitle}
        </Typography>

        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{
            mr: 2,
            display: { xs: 'block', lg: 'none' },

          }}
        >
          <MenuIcon />
        </IconButton>
        <Box component="span" sx={{ flex: 1 }} />
        <NotificationCenter
          coproprietaireId={
            coproprietaire?.id ? `coowner-${coproprietaire?.id}` : null
          }
        />
      </Toolbar>
    </AppBar>
  )
}
